import React from 'react';

import ColoredCheckbox from '../../../../components/ColoredCheckbox';

import { __ } from '../../../../i18n';

const styles = {
  checked: {
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#F2F7FF',
    borderRadius: '8px',
    width: '183px',
    padding: '16px'
  },
  notChecked: {
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '16px',
    padding: '16px 16px 16px 0'
  },
  label: {
    fontWeight: 400,
    fontSize: '16px',
    marginLeft: '8px'
  }
};

export default class ReportCheckbox extends React.Component {
  render() {
    const { checked, setValue } = this.props;

    return (
      <div style={checked ? styles.checked : styles.notChecked}>
        <ColoredCheckbox
          radio
          radioChecked
          color="#084FFF"
          checked={checked}
          onClick={() => { setValue(!checked); }}
        />
        <span style={styles.label}>{__('Report Mode')}</span>
      </div>
    );
  }
}
